import ProjectFormPage from '@/pages/ProjectFormPage.vue';
import ProjectsPage from '@/pages/ProjectsPage.vue';
import ProjectsArchivedPage from '@/pages/ProjectsArchivedPage.vue';
import ProjectDetailPage from '@/pages/ProjectDetailPage.vue';
import ProjectStagesPage from '@/pages/ProjectStagesPage.vue';
import ProjectDescriptionPage from '@/pages/ProjectDescriptionPage.vue';
import ProjectFilesPage from '@/pages/ProjectFilesPage.vue';
import ProjectEventsPage from '@/pages/ProjectEventsPage.vue';
import ProjectMembersPage from '@/pages/ProjectMembersPage.vue';
import TaskDetailPage from '@/pages/TaskDetailPage.vue';
import TaskForm from '@/components/TaskForm.vue'; // todo move to pages
import ProjectsPage2 from '../../pages/ProjectsPage2.vue';
import ProjectsArchivedPage2 from '../../pages/ProjectsArchivedPage2.vue';
import TasksPage from '../../pages/TasksPage.vue';

export default [
  {
    path: '/projects',
    name: 'project-list',
    component: ProjectsPage2,
    meta: { title: 'Проекты' },
  },
  {
    path: '/projects2',
    name: 'project-list2',
    component: ProjectsPage,
    meta: { title: 'Проекты' },
  },
  {
    path: '/projects/archived',
    name: 'project-list-archived',
    component: ProjectsArchivedPage2,
    meta: { title: 'Архивные проекты' },
  },
  {
    path: '/projects/archived2',
    name: 'project-list-archived2',
    component: ProjectsArchivedPage,
    meta: { title: 'Архивные проекты' },
  },
  {
    path: '/projects/new',
    name: 'project-create',
    component: ProjectFormPage,
    meta: { title: 'Новый проект' },
  },
  {
    path: '/projects/:projectId/edit',
    name: 'project-edit',
    component: ProjectFormPage,
  },
  {
    path: '/projects/:projectId',
    name: 'project-detail',
    component: ProjectDetailPage,
    children: [
      {
        path: 'stages',
        name: 'project-stages',
        component: ProjectStagesPage,
        meta: { showProjectHeader: true },
      },
      {
        path: 'stages/:stageId/tasks/new',
        name: 'task-create',
        component: TaskForm,
      },
      {
        path: 'stages/:stageId/tasks/:taskId',
        name: 'task-detail',
        component: TaskDetailPage,
      },
      {
        path: 'stages/:stageId/tasks/:taskId/edit',
        name: 'task-edit',
        component: TaskForm,
      },
      {
        path: 'description',
        name: 'project-description',
        component: ProjectDescriptionPage,
        meta: { showProjectHeader: true },
      },
      {
        path: 'files',
        name: 'project-files',
        component: ProjectFilesPage,
      },
      {
        path: 'events',
        name: 'project-events',
        component: ProjectEventsPage,
      },
      {
        path: 'members',
        name: 'project-members',
        component: ProjectMembersPage,
      },
    ],
  },
  {
    path: '/tasks',
    name: 'my-task-list',
    component: TasksPage,
    meta: { title: 'Мои задачи' },
  },
];
